import { useEffect } from 'react';

const PageWrapper = ({ title, children }) => {
  useEffect(() => {
    document.title = `${title} - NeoTerra Admin`;
  }, [title]);

  return children;
};

export default PageWrapper;